import { questionOrderOptions } from "modules/Faq/faqhelpers";
import React from "react";
import {
  Col,
  Row,
  Input,
  Label,
  FormFeedback,
  Button,
} from "reactstrap";



interface FaqCategoryFormProps {
  validation: any;
  isEdit?: boolean;
  categories: any[];
}

const CategoryForm: React.FC<FaqCategoryFormProps> = ({
  validation,
  isEdit = false,
  categories,
}) => {
  return (
    <form onSubmit={validation.handleSubmit}>
      <div className="px-3 py-2">
        <h5>{isEdit ? "Edit Category" : "New Category"}</h5>
         <Row className="g-3 mt-2">
          <Col md={12}>
            <Label>Category Name *</Label>
            <Input
              name="category_name"
              value={validation.values.category_name}
              onChange={validation.handleChange}
              invalid={!!(validation.touched.category_name && validation.errors.category_name)}
              placeholder="Type here..."
              disabled={isEdit}   
              style={isEdit ? { cursor: "not-allowed" } : {}}
            />
            <FormFeedback>{validation.errors.category_name}</FormFeedback>
          </Col>
        </Row>
        <Row className="g-3 mt-2">
        <Col md={6}>
            <Label>Status *</Label>
            <Input
                type="select"
                name="status"
                value={validation.values.status}
                onChange={validation.handleChange}
                invalid={!!(validation.touched.status && validation.errors.status)}
                >
                <option value="" disabled hidden>Select Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
                
            </Input>
            <FormFeedback>{validation.errors.status}</FormFeedback>
            </Col>
          <Col md={6}>
            <Label>Select Order *</Label>
            <Input
              type="select"
              name="category_order"
              value={validation.values.category_order}
              onChange={validation.handleChange}
              invalid={!!(validation.touched.category_order && validation.errors.category_order)}
              >
              <option value="" disabled hidden>Select </option>
                {questionOrderOptions.map((item) => (
                    <option key={item.value} value={item.value}>
                    {item.label}
                    </option>
                ))}
            </Input>
            <FormFeedback>{validation.errors.category_order}</FormFeedback>
          </Col>
        </Row>
        <div className="d-flex justify-content-end mt-4">
          <Button color="primary" type="submit">
            {isEdit ? "Update" : "Done"}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default CategoryForm;
